const Home = () => {
    return (
      <>
        <main>
        <p>At Game Reviews we are devoted to getting people 
          together to play brilliant games.</p>

        <img id="cover_img" src="https://images.unsplash.com/photo-1563941402830-3bae42b67b38?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8bWVlcGxlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"></img> 

        <p>On our site you'll find reviews for a real range 
          of different games. Our writers have reviewed the 
          classics like Monopoly & Twister as well as huge 
          strategy games like Scythe. Please feel free to leave 
          us comments on reviews, we would love to hear which are 
          your favourites.
        </p>
        </main>
      </>
    )
  }
  
  export default Home